
import {
  OBTENER_ALTAS_MODIFICAR_REQUEST,
  OBTENER_ALTAS_MODIFICAR_SUCCESS,
  OBTENER_ALTAS_MODIFICAR_FAIL
} from '../../../actions/Altas/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  listaAltasModificar: Array<{
    aF_CLAVE: number,
    ninv: string,
    altaS_CORR: string,
    serv: string,
    dep: string,
    esp: string,
    ncuenta: string,
    marca: string,
    modelo: string,
    serie: string,
    estado: string,
    precio: string,
    fechA_ALTA: string,
    nrecep: string
  }>;
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  listaAltasModificar: []
};

// Reducer con tipos definidos
const listaAltasModificarReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case OBTENER_ALTAS_MODIFICAR_REQUEST:
      return { ...state, loading: true };
    case OBTENER_ALTAS_MODIFICAR_SUCCESS:
      return {
        ...state,
        loading: false,
        listaAltasModificar: action.payload,
      };
    case OBTENER_ALTAS_MODIFICAR_FAIL:
      return {
        ...initialState, loading: false,
        error: action.error,
        listaAltasModificar: []
      };
    default:
      return state;
  }
};



export default listaAltasModificarReducers;
